//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class CampayaCoreApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param eventType (optional)
     * @param propertyId (optional)
     * @param listIndex (optional)
     * @return Success
     */
    trackSearchResultPropertyGET(eventType?: DbAnalyticEventTypes | undefined, propertyId?: string | undefined, listIndex?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/analytics/TrackSearchResultProperty?";
        if (eventType === null)
            throw new Error("The parameter 'eventType' cannot be null.");
        else if (eventType !== undefined)
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (listIndex === null)
            throw new Error("The parameter 'listIndex' cannot be null.");
        else if (listIndex !== undefined)
            url_ += "listIndex=" + encodeURIComponent("" + listIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTrackSearchResultPropertyGET(_response);
        });
    }

    protected processTrackSearchResultPropertyGET(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param eventType (optional)
     * @param propertyId (optional)
     * @param listIndex (optional)
     * @return Success
     */
    trackSearchResultPropertyPOST(eventType?: DbAnalyticEventTypes | undefined, propertyId?: string | undefined, listIndex?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/analytics/TrackSearchResultProperty?";
        if (eventType === null)
            throw new Error("The parameter 'eventType' cannot be null.");
        else if (eventType !== undefined)
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (listIndex === null)
            throw new Error("The parameter 'listIndex' cannot be null.");
        else if (listIndex !== undefined)
            url_ += "listIndex=" + encodeURIComponent("" + listIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTrackSearchResultPropertyPOST(_response);
        });
    }

    protected processTrackSearchResultPropertyPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @param selectedOptions (optional)
     * @param priceAndFeesRequest_FromDate (optional)
     * @param priceAndFeesRequest_ToDate (optional)
     * @param priceAndFeesRequest_Pets (optional)
     * @param priceAndFeesRequest_BookServices (optional)
     * @param priceAndFeesRequest_DiscountCode (optional)
     * @param priceAndFeesRequest_LanguageCurrencyKey (optional)
     * @param priceAndFeesRequest_Language (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_SalesPartner (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_BookingNumber (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_ServicePrices (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_RentalPrice (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_RentalCommission (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_CommissionPercentage (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_CancellationTerm (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_StayPrice (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_IsDirectApiBooking (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_IsAffiliateBooking (optional)
     * @param priceAndFeesRequest_HybridDetails_RentalPrice (optional)
     * @param priceAndFeesRequest_HybridDetails_HybridFeeDetails (optional)
     * @param priceAndFeesRequest_ThrowErrorOnInvalidMandatoryGroupSelection (optional)
     * @param priceAndFeesRequest_FeeLanguage (optional)
     * @param priceAndFeesRequest_AddAdminAndInsuranceMarkupToServices (optional)
     * @return Success
     */
    reservation(priceAndFeesRequest_Adults: number, priceAndFeesRequest_Children: number, priceAndFeesRequest_Infants: number, propertyId?: string | undefined, selectedOptions?: SelectedBookingOption[] | undefined, priceAndFeesRequest_FromDate?: Date | undefined, priceAndFeesRequest_ToDate?: Date | undefined, priceAndFeesRequest_Pets?: number | undefined, priceAndFeesRequest_BookServices?: { [key: string]: number; } | undefined, priceAndFeesRequest_DiscountCode?: string | undefined, priceAndFeesRequest_LanguageCurrencyKey?: string | undefined, priceAndFeesRequest_Language?: string | undefined, priceAndFeesRequest_SalesPartnerDetails_SalesPartner?: number | undefined, priceAndFeesRequest_SalesPartnerDetails_BookingNumber?: string | undefined, priceAndFeesRequest_SalesPartnerDetails_ServicePrices?: { [key: string]: number; } | undefined, priceAndFeesRequest_SalesPartnerDetails_RentalPrice?: number | undefined, priceAndFeesRequest_SalesPartnerDetails_RentalCommission?: number | undefined, priceAndFeesRequest_SalesPartnerDetails_CommissionPercentage?: number | undefined, priceAndFeesRequest_SalesPartnerDetails_CancellationTerm?: number | undefined, priceAndFeesRequest_SalesPartnerDetails_StayPrice?: number | undefined, priceAndFeesRequest_SalesPartnerDetails_IsDirectApiBooking?: boolean | undefined, priceAndFeesRequest_SalesPartnerDetails_IsAffiliateBooking?: boolean | undefined, priceAndFeesRequest_HybridDetails_RentalPrice?: number | undefined, priceAndFeesRequest_HybridDetails_HybridFeeDetails?: HybridFeeDetail[] | undefined, priceAndFeesRequest_ThrowErrorOnInvalidMandatoryGroupSelection?: boolean | undefined, priceAndFeesRequest_FeeLanguage?: Language | undefined, priceAndFeesRequest_AddAdminAndInsuranceMarkupToServices?: boolean | undefined): Promise<BookingFlowResponseModel> {
        let url_ = this.baseUrl + "/api/reservation?";
        if (priceAndFeesRequest_Adults === undefined || priceAndFeesRequest_Adults === null)
            throw new Error("The parameter 'priceAndFeesRequest_Adults' must be defined and cannot be null.");
        else
            url_ += "PriceAndFeesRequest.Adults=" + encodeURIComponent("" + priceAndFeesRequest_Adults) + "&";
        if (priceAndFeesRequest_Children === undefined || priceAndFeesRequest_Children === null)
            throw new Error("The parameter 'priceAndFeesRequest_Children' must be defined and cannot be null.");
        else
            url_ += "PriceAndFeesRequest.Children=" + encodeURIComponent("" + priceAndFeesRequest_Children) + "&";
        if (priceAndFeesRequest_Infants === undefined || priceAndFeesRequest_Infants === null)
            throw new Error("The parameter 'priceAndFeesRequest_Infants' must be defined and cannot be null.");
        else
            url_ += "PriceAndFeesRequest.Infants=" + encodeURIComponent("" + priceAndFeesRequest_Infants) + "&";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (selectedOptions === null)
            throw new Error("The parameter 'selectedOptions' cannot be null.");
        else if (selectedOptions !== undefined)
            selectedOptions && selectedOptions.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SelectedOptions[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (priceAndFeesRequest_FromDate === null)
            throw new Error("The parameter 'priceAndFeesRequest_FromDate' cannot be null.");
        else if (priceAndFeesRequest_FromDate !== undefined)
            url_ += "PriceAndFeesRequest.FromDate=" + encodeURIComponent(priceAndFeesRequest_FromDate ? "" + priceAndFeesRequest_FromDate.toISOString() : "") + "&";
        if (priceAndFeesRequest_ToDate === null)
            throw new Error("The parameter 'priceAndFeesRequest_ToDate' cannot be null.");
        else if (priceAndFeesRequest_ToDate !== undefined)
            url_ += "PriceAndFeesRequest.ToDate=" + encodeURIComponent(priceAndFeesRequest_ToDate ? "" + priceAndFeesRequest_ToDate.toISOString() : "") + "&";
        if (priceAndFeesRequest_Pets === null)
            throw new Error("The parameter 'priceAndFeesRequest_Pets' cannot be null.");
        else if (priceAndFeesRequest_Pets !== undefined)
            url_ += "PriceAndFeesRequest.Pets=" + encodeURIComponent("" + priceAndFeesRequest_Pets) + "&";
        if (priceAndFeesRequest_BookServices === null)
            throw new Error("The parameter 'priceAndFeesRequest_BookServices' cannot be null.");
        else if (priceAndFeesRequest_BookServices !== undefined)
            url_ += "PriceAndFeesRequest.BookServices=" + encodeURIComponent("" + priceAndFeesRequest_BookServices) + "&";
        if (priceAndFeesRequest_DiscountCode === null)
            throw new Error("The parameter 'priceAndFeesRequest_DiscountCode' cannot be null.");
        else if (priceAndFeesRequest_DiscountCode !== undefined)
            url_ += "PriceAndFeesRequest.DiscountCode=" + encodeURIComponent("" + priceAndFeesRequest_DiscountCode) + "&";
        if (priceAndFeesRequest_LanguageCurrencyKey === null)
            throw new Error("The parameter 'priceAndFeesRequest_LanguageCurrencyKey' cannot be null.");
        else if (priceAndFeesRequest_LanguageCurrencyKey !== undefined)
            url_ += "PriceAndFeesRequest.LanguageCurrencyKey=" + encodeURIComponent("" + priceAndFeesRequest_LanguageCurrencyKey) + "&";
        if (priceAndFeesRequest_Language === null)
            throw new Error("The parameter 'priceAndFeesRequest_Language' cannot be null.");
        else if (priceAndFeesRequest_Language !== undefined)
            url_ += "PriceAndFeesRequest.Language=" + encodeURIComponent("" + priceAndFeesRequest_Language) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_SalesPartner === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_SalesPartner' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_SalesPartner !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.SalesPartner=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_SalesPartner) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_BookingNumber === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_BookingNumber' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_BookingNumber !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.BookingNumber=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_BookingNumber) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_ServicePrices === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_ServicePrices' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_ServicePrices !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.ServicePrices=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_ServicePrices) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_RentalPrice === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_RentalPrice' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_RentalPrice !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.RentalPrice=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_RentalPrice) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_RentalCommission === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_RentalCommission' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_RentalCommission !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.RentalCommission=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_RentalCommission) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_CommissionPercentage === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_CommissionPercentage' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_CommissionPercentage !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.CommissionPercentage=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_CommissionPercentage) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_CancellationTerm === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_CancellationTerm' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_CancellationTerm !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.CancellationTerm=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_CancellationTerm) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_StayPrice === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_StayPrice' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_StayPrice !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.StayPrice=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_StayPrice) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_IsDirectApiBooking === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_IsDirectApiBooking' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_IsDirectApiBooking !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.IsDirectApiBooking=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_IsDirectApiBooking) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_IsAffiliateBooking === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_IsAffiliateBooking' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_IsAffiliateBooking !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.IsAffiliateBooking=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_IsAffiliateBooking) + "&";
        if (priceAndFeesRequest_HybridDetails_RentalPrice === null)
            throw new Error("The parameter 'priceAndFeesRequest_HybridDetails_RentalPrice' cannot be null.");
        else if (priceAndFeesRequest_HybridDetails_RentalPrice !== undefined)
            url_ += "PriceAndFeesRequest.HybridDetails.RentalPrice=" + encodeURIComponent("" + priceAndFeesRequest_HybridDetails_RentalPrice) + "&";
        if (priceAndFeesRequest_HybridDetails_HybridFeeDetails === null)
            throw new Error("The parameter 'priceAndFeesRequest_HybridDetails_HybridFeeDetails' cannot be null.");
        else if (priceAndFeesRequest_HybridDetails_HybridFeeDetails !== undefined)
            priceAndFeesRequest_HybridDetails_HybridFeeDetails && priceAndFeesRequest_HybridDetails_HybridFeeDetails.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "PriceAndFeesRequest.HybridDetails.HybridFeeDetails[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (priceAndFeesRequest_ThrowErrorOnInvalidMandatoryGroupSelection === null)
            throw new Error("The parameter 'priceAndFeesRequest_ThrowErrorOnInvalidMandatoryGroupSelection' cannot be null.");
        else if (priceAndFeesRequest_ThrowErrorOnInvalidMandatoryGroupSelection !== undefined)
            url_ += "PriceAndFeesRequest.ThrowErrorOnInvalidMandatoryGroupSelection=" + encodeURIComponent("" + priceAndFeesRequest_ThrowErrorOnInvalidMandatoryGroupSelection) + "&";
        if (priceAndFeesRequest_FeeLanguage === null)
            throw new Error("The parameter 'priceAndFeesRequest_FeeLanguage' cannot be null.");
        else if (priceAndFeesRequest_FeeLanguage !== undefined)
            url_ += "PriceAndFeesRequest.FeeLanguage=" + encodeURIComponent("" + priceAndFeesRequest_FeeLanguage) + "&";
        if (priceAndFeesRequest_AddAdminAndInsuranceMarkupToServices === null)
            throw new Error("The parameter 'priceAndFeesRequest_AddAdminAndInsuranceMarkupToServices' cannot be null.");
        else if (priceAndFeesRequest_AddAdminAndInsuranceMarkupToServices !== undefined)
            url_ += "PriceAndFeesRequest.AddAdminAndInsuranceMarkupToServices=" + encodeURIComponent("" + priceAndFeesRequest_AddAdminAndInsuranceMarkupToServices) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReservation(_response);
        });
    }

    protected processReservation(response: Response): Promise<BookingFlowResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BookingFlowResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookingFlowResponseModel>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @param selectedOptions (optional)
     * @param priceAndFeesRequest_FromDate (optional)
     * @param priceAndFeesRequest_ToDate (optional)
     * @param priceAndFeesRequest_Pets (optional)
     * @param priceAndFeesRequest_BookServices (optional)
     * @param priceAndFeesRequest_DiscountCode (optional)
     * @param priceAndFeesRequest_LanguageCurrencyKey (optional)
     * @param priceAndFeesRequest_Language (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_SalesPartner (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_BookingNumber (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_ServicePrices (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_RentalPrice (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_RentalCommission (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_CommissionPercentage (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_CancellationTerm (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_StayPrice (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_IsDirectApiBooking (optional)
     * @param priceAndFeesRequest_SalesPartnerDetails_IsAffiliateBooking (optional)
     * @param priceAndFeesRequest_HybridDetails_RentalPrice (optional)
     * @param priceAndFeesRequest_HybridDetails_HybridFeeDetails (optional)
     * @param priceAndFeesRequest_ThrowErrorOnInvalidMandatoryGroupSelection (optional)
     * @param priceAndFeesRequest_FeeLanguage (optional)
     * @param priceAndFeesRequest_AddAdminAndInsuranceMarkupToServices (optional)
     * @return Success
     */
    totalPrice(priceAndFeesRequest_Adults: number, priceAndFeesRequest_Children: number, priceAndFeesRequest_Infants: number, propertyId?: string | undefined, selectedOptions?: SelectedBookingOption[] | undefined, priceAndFeesRequest_FromDate?: Date | undefined, priceAndFeesRequest_ToDate?: Date | undefined, priceAndFeesRequest_Pets?: number | undefined, priceAndFeesRequest_BookServices?: { [key: string]: number; } | undefined, priceAndFeesRequest_DiscountCode?: string | undefined, priceAndFeesRequest_LanguageCurrencyKey?: string | undefined, priceAndFeesRequest_Language?: string | undefined, priceAndFeesRequest_SalesPartnerDetails_SalesPartner?: number | undefined, priceAndFeesRequest_SalesPartnerDetails_BookingNumber?: string | undefined, priceAndFeesRequest_SalesPartnerDetails_ServicePrices?: { [key: string]: number; } | undefined, priceAndFeesRequest_SalesPartnerDetails_RentalPrice?: number | undefined, priceAndFeesRequest_SalesPartnerDetails_RentalCommission?: number | undefined, priceAndFeesRequest_SalesPartnerDetails_CommissionPercentage?: number | undefined, priceAndFeesRequest_SalesPartnerDetails_CancellationTerm?: number | undefined, priceAndFeesRequest_SalesPartnerDetails_StayPrice?: number | undefined, priceAndFeesRequest_SalesPartnerDetails_IsDirectApiBooking?: boolean | undefined, priceAndFeesRequest_SalesPartnerDetails_IsAffiliateBooking?: boolean | undefined, priceAndFeesRequest_HybridDetails_RentalPrice?: number | undefined, priceAndFeesRequest_HybridDetails_HybridFeeDetails?: HybridFeeDetail[] | undefined, priceAndFeesRequest_ThrowErrorOnInvalidMandatoryGroupSelection?: boolean | undefined, priceAndFeesRequest_FeeLanguage?: Language | undefined, priceAndFeesRequest_AddAdminAndInsuranceMarkupToServices?: boolean | undefined): Promise<TotalPrice> {
        let url_ = this.baseUrl + "/api/reservation/total-price?";
        if (priceAndFeesRequest_Adults === undefined || priceAndFeesRequest_Adults === null)
            throw new Error("The parameter 'priceAndFeesRequest_Adults' must be defined and cannot be null.");
        else
            url_ += "PriceAndFeesRequest.Adults=" + encodeURIComponent("" + priceAndFeesRequest_Adults) + "&";
        if (priceAndFeesRequest_Children === undefined || priceAndFeesRequest_Children === null)
            throw new Error("The parameter 'priceAndFeesRequest_Children' must be defined and cannot be null.");
        else
            url_ += "PriceAndFeesRequest.Children=" + encodeURIComponent("" + priceAndFeesRequest_Children) + "&";
        if (priceAndFeesRequest_Infants === undefined || priceAndFeesRequest_Infants === null)
            throw new Error("The parameter 'priceAndFeesRequest_Infants' must be defined and cannot be null.");
        else
            url_ += "PriceAndFeesRequest.Infants=" + encodeURIComponent("" + priceAndFeesRequest_Infants) + "&";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (selectedOptions === null)
            throw new Error("The parameter 'selectedOptions' cannot be null.");
        else if (selectedOptions !== undefined)
            selectedOptions && selectedOptions.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SelectedOptions[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (priceAndFeesRequest_FromDate === null)
            throw new Error("The parameter 'priceAndFeesRequest_FromDate' cannot be null.");
        else if (priceAndFeesRequest_FromDate !== undefined)
            url_ += "PriceAndFeesRequest.FromDate=" + encodeURIComponent(priceAndFeesRequest_FromDate ? "" + priceAndFeesRequest_FromDate.toISOString() : "") + "&";
        if (priceAndFeesRequest_ToDate === null)
            throw new Error("The parameter 'priceAndFeesRequest_ToDate' cannot be null.");
        else if (priceAndFeesRequest_ToDate !== undefined)
            url_ += "PriceAndFeesRequest.ToDate=" + encodeURIComponent(priceAndFeesRequest_ToDate ? "" + priceAndFeesRequest_ToDate.toISOString() : "") + "&";
        if (priceAndFeesRequest_Pets === null)
            throw new Error("The parameter 'priceAndFeesRequest_Pets' cannot be null.");
        else if (priceAndFeesRequest_Pets !== undefined)
            url_ += "PriceAndFeesRequest.Pets=" + encodeURIComponent("" + priceAndFeesRequest_Pets) + "&";
        if (priceAndFeesRequest_BookServices === null)
            throw new Error("The parameter 'priceAndFeesRequest_BookServices' cannot be null.");
        else if (priceAndFeesRequest_BookServices !== undefined)
            url_ += "PriceAndFeesRequest.BookServices=" + encodeURIComponent("" + priceAndFeesRequest_BookServices) + "&";
        if (priceAndFeesRequest_DiscountCode === null)
            throw new Error("The parameter 'priceAndFeesRequest_DiscountCode' cannot be null.");
        else if (priceAndFeesRequest_DiscountCode !== undefined)
            url_ += "PriceAndFeesRequest.DiscountCode=" + encodeURIComponent("" + priceAndFeesRequest_DiscountCode) + "&";
        if (priceAndFeesRequest_LanguageCurrencyKey === null)
            throw new Error("The parameter 'priceAndFeesRequest_LanguageCurrencyKey' cannot be null.");
        else if (priceAndFeesRequest_LanguageCurrencyKey !== undefined)
            url_ += "PriceAndFeesRequest.LanguageCurrencyKey=" + encodeURIComponent("" + priceAndFeesRequest_LanguageCurrencyKey) + "&";
        if (priceAndFeesRequest_Language === null)
            throw new Error("The parameter 'priceAndFeesRequest_Language' cannot be null.");
        else if (priceAndFeesRequest_Language !== undefined)
            url_ += "PriceAndFeesRequest.Language=" + encodeURIComponent("" + priceAndFeesRequest_Language) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_SalesPartner === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_SalesPartner' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_SalesPartner !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.SalesPartner=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_SalesPartner) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_BookingNumber === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_BookingNumber' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_BookingNumber !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.BookingNumber=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_BookingNumber) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_ServicePrices === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_ServicePrices' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_ServicePrices !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.ServicePrices=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_ServicePrices) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_RentalPrice === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_RentalPrice' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_RentalPrice !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.RentalPrice=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_RentalPrice) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_RentalCommission === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_RentalCommission' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_RentalCommission !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.RentalCommission=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_RentalCommission) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_CommissionPercentage === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_CommissionPercentage' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_CommissionPercentage !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.CommissionPercentage=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_CommissionPercentage) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_CancellationTerm === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_CancellationTerm' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_CancellationTerm !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.CancellationTerm=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_CancellationTerm) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_StayPrice === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_StayPrice' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_StayPrice !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.StayPrice=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_StayPrice) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_IsDirectApiBooking === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_IsDirectApiBooking' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_IsDirectApiBooking !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.IsDirectApiBooking=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_IsDirectApiBooking) + "&";
        if (priceAndFeesRequest_SalesPartnerDetails_IsAffiliateBooking === null)
            throw new Error("The parameter 'priceAndFeesRequest_SalesPartnerDetails_IsAffiliateBooking' cannot be null.");
        else if (priceAndFeesRequest_SalesPartnerDetails_IsAffiliateBooking !== undefined)
            url_ += "PriceAndFeesRequest.SalesPartnerDetails.IsAffiliateBooking=" + encodeURIComponent("" + priceAndFeesRequest_SalesPartnerDetails_IsAffiliateBooking) + "&";
        if (priceAndFeesRequest_HybridDetails_RentalPrice === null)
            throw new Error("The parameter 'priceAndFeesRequest_HybridDetails_RentalPrice' cannot be null.");
        else if (priceAndFeesRequest_HybridDetails_RentalPrice !== undefined)
            url_ += "PriceAndFeesRequest.HybridDetails.RentalPrice=" + encodeURIComponent("" + priceAndFeesRequest_HybridDetails_RentalPrice) + "&";
        if (priceAndFeesRequest_HybridDetails_HybridFeeDetails === null)
            throw new Error("The parameter 'priceAndFeesRequest_HybridDetails_HybridFeeDetails' cannot be null.");
        else if (priceAndFeesRequest_HybridDetails_HybridFeeDetails !== undefined)
            priceAndFeesRequest_HybridDetails_HybridFeeDetails && priceAndFeesRequest_HybridDetails_HybridFeeDetails.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "PriceAndFeesRequest.HybridDetails.HybridFeeDetails[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (priceAndFeesRequest_ThrowErrorOnInvalidMandatoryGroupSelection === null)
            throw new Error("The parameter 'priceAndFeesRequest_ThrowErrorOnInvalidMandatoryGroupSelection' cannot be null.");
        else if (priceAndFeesRequest_ThrowErrorOnInvalidMandatoryGroupSelection !== undefined)
            url_ += "PriceAndFeesRequest.ThrowErrorOnInvalidMandatoryGroupSelection=" + encodeURIComponent("" + priceAndFeesRequest_ThrowErrorOnInvalidMandatoryGroupSelection) + "&";
        if (priceAndFeesRequest_FeeLanguage === null)
            throw new Error("The parameter 'priceAndFeesRequest_FeeLanguage' cannot be null.");
        else if (priceAndFeesRequest_FeeLanguage !== undefined)
            url_ += "PriceAndFeesRequest.FeeLanguage=" + encodeURIComponent("" + priceAndFeesRequest_FeeLanguage) + "&";
        if (priceAndFeesRequest_AddAdminAndInsuranceMarkupToServices === null)
            throw new Error("The parameter 'priceAndFeesRequest_AddAdminAndInsuranceMarkupToServices' cannot be null.");
        else if (priceAndFeesRequest_AddAdminAndInsuranceMarkupToServices !== undefined)
            url_ += "PriceAndFeesRequest.AddAdminAndInsuranceMarkupToServices=" + encodeURIComponent("" + priceAndFeesRequest_AddAdminAndInsuranceMarkupToServices) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTotalPrice(_response);
        });
    }

    protected processTotalPrice(response: Response): Promise<TotalPrice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TotalPrice;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TotalPrice>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @param body (optional)
     * @return Success
     */
    book(propertyId?: string | undefined, body?: BookingRequest | undefined): Promise<BookingResponseModel> {
        let url_ = this.baseUrl + "/api/reservation/book?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBook(_response);
        });
    }

    protected processBook(response: Response): Promise<BookingResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BookingResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookingResponseModel>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @param agencyBookingNumber (optional)
     * @param bookingId (optional)
     * @param email (optional)
     * @return Success
     */
    getBooking(propertyId?: string | undefined, agencyBookingNumber?: string | undefined, bookingId?: number | undefined, email?: string | undefined): Promise<BookingResponseModel> {
        let url_ = this.baseUrl + "/api/reservation/get-booking?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (agencyBookingNumber === null)
            throw new Error("The parameter 'agencyBookingNumber' cannot be null.");
        else if (agencyBookingNumber !== undefined)
            url_ += "agencyBookingNumber=" + encodeURIComponent("" + agencyBookingNumber) + "&";
        if (bookingId === null)
            throw new Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBooking(_response);
        });
    }

    protected processGetBooking(response: Response): Promise<BookingResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BookingResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookingResponseModel>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @param agencyBookingNumber (optional)
     * @return Success
     */
    markBookingAsAnalyticTracked(propertyId?: string | undefined, agencyBookingNumber?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/reservation/mark-booking-as-analytic-tracked?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (agencyBookingNumber === null)
            throw new Error("The parameter 'agencyBookingNumber' cannot be null.");
        else if (agencyBookingNumber !== undefined)
            url_ += "agencyBookingNumber=" + encodeURIComponent("" + agencyBookingNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkBookingAsAnalyticTracked(_response);
        });
    }

    protected processMarkBookingAsAnalyticTracked(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @param agencyBookingNumber (optional)
     * @param selectedPaymentMethod (optional)
     * @return Success
     */
    createPayment(propertyId?: string | undefined, agencyBookingNumber?: string | undefined, selectedPaymentMethod?: string | undefined): Promise<BookingCreatePaymentResponseModel> {
        let url_ = this.baseUrl + "/api/reservation/create-payment?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (agencyBookingNumber === null)
            throw new Error("The parameter 'agencyBookingNumber' cannot be null.");
        else if (agencyBookingNumber !== undefined)
            url_ += "agencyBookingNumber=" + encodeURIComponent("" + agencyBookingNumber) + "&";
        if (selectedPaymentMethod === null)
            throw new Error("The parameter 'selectedPaymentMethod' cannot be null.");
        else if (selectedPaymentMethod !== undefined)
            url_ += "selectedPaymentMethod=" + encodeURIComponent("" + selectedPaymentMethod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePayment(_response);
        });
    }

    protected processCreatePayment(response: Response): Promise<BookingCreatePaymentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BookingCreatePaymentResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookingCreatePaymentResponseModel>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @param agencyBookingNumber (optional)
     * @return Success
     */
    getPaymentInformation(propertyId?: string | undefined, agencyBookingNumber?: string | undefined): Promise<PaymentInformation> {
        let url_ = this.baseUrl + "/api/reservation/get-payment-information?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (agencyBookingNumber === null)
            throw new Error("The parameter 'agencyBookingNumber' cannot be null.");
        else if (agencyBookingNumber !== undefined)
            url_ += "agencyBookingNumber=" + encodeURIComponent("" + agencyBookingNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPaymentInformation(_response);
        });
    }

    protected processGetPaymentInformation(response: Response): Promise<PaymentInformation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentInformation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentInformation>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @param agencyBookingNumber (optional)
     * @param serviceId (optional)
     * @param arrivalValue (optional)
     * @param departureValue (optional)
     * @return Success
     */
    saveConsumptionReading(propertyId?: string | undefined, agencyBookingNumber?: string | undefined, serviceId?: number | undefined, arrivalValue?: number | undefined, departureValue?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/reservation/save-consumption-reading?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (agencyBookingNumber === null)
            throw new Error("The parameter 'agencyBookingNumber' cannot be null.");
        else if (agencyBookingNumber !== undefined)
            url_ += "agencyBookingNumber=" + encodeURIComponent("" + agencyBookingNumber) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        if (arrivalValue === null)
            throw new Error("The parameter 'arrivalValue' cannot be null.");
        else if (arrivalValue !== undefined)
            url_ += "arrivalValue=" + encodeURIComponent("" + arrivalValue) + "&";
        if (departureValue === null)
            throw new Error("The parameter 'departureValue' cannot be null.");
        else if (departureValue !== undefined)
            url_ += "departureValue=" + encodeURIComponent("" + departureValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveConsumptionReading(_response);
        });
    }

    protected processSaveConsumptionReading(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param propertyIdWithType (optional)
     * @param agencyBookingNumber (optional)
     * @return Success
     */
    externalPayment(propertyIdWithType?: string | undefined, agencyBookingNumber?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/reservation/external-payment?";
        if (propertyIdWithType === null)
            throw new Error("The parameter 'propertyIdWithType' cannot be null.");
        else if (propertyIdWithType !== undefined)
            url_ += "propertyIdWithType=" + encodeURIComponent("" + propertyIdWithType) + "&";
        if (agencyBookingNumber === null)
            throw new Error("The parameter 'agencyBookingNumber' cannot be null.");
        else if (agencyBookingNumber !== undefined)
            url_ += "agencyBookingNumber=" + encodeURIComponent("" + agencyBookingNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExternalPayment(_response);
        });
    }

    protected processExternalPayment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    phonePrefixes(): Promise<number[]> {
        let url_ = this.baseUrl + "/api/constants/phone-prefixes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhonePrefixes(_response);
        });
    }

    protected processPhonePrefixes(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * @param guid (optional)
     * @return Success
     */
    getShortlist(guid?: string | undefined): Promise<ShortListProperties> {
        let url_ = this.baseUrl + "/api/favorites/get-shortlist?";
        if (guid === null)
            throw new Error("The parameter 'guid' cannot be null.");
        else if (guid !== undefined)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetShortlist(_response);
        });
    }

    protected processGetShortlist(response: Response): Promise<ShortListProperties> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShortListProperties;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShortListProperties>(null as any);
    }

    /**
     * @param areaId (optional)
     * @return Success
     */
    getPopularList(areaId?: number | undefined): Promise<ShortListProperties> {
        let url_ = this.baseUrl + "/api/favorites/get-popular-list?";
        if (areaId === null)
            throw new Error("The parameter 'areaId' cannot be null.");
        else if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPopularList(_response);
        });
    }

    protected processGetPopularList(response: Response): Promise<ShortListProperties> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShortListProperties;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShortListProperties>(null as any);
    }

    /**
     * @param subject (optional)
     * @param content (optional)
     * @param logType (optional)
     * @return Success
     */
    log(subject?: string | undefined, content?: string | undefined, logType?: LogTypes | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/logging/Log?";
        if (subject === null)
            throw new Error("The parameter 'subject' cannot be null.");
        else if (subject !== undefined)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&";
        if (content === null)
            throw new Error("The parameter 'content' cannot be null.");
        else if (content !== undefined)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        if (logType === null)
            throw new Error("The parameter 'logType' cannot be null.");
        else if (logType !== undefined)
            url_ += "logType=" + encodeURIComponent("" + logType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLog(_response);
        });
    }

    protected processLog(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param isOnline (optional)
     * @return Success
     */
    getMeetingEvents(isOnline?: boolean | undefined): Promise<MeetingEvent[]> {
        let url_ = this.baseUrl + "/api/meeting/GetMeetingEvents?";
        if (isOnline === null)
            throw new Error("The parameter 'isOnline' cannot be null.");
        else if (isOnline !== undefined)
            url_ += "isOnline=" + encodeURIComponent("" + isOnline) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeetingEvents(_response);
        });
    }

    protected processGetMeetingEvents(response: Response): Promise<MeetingEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MeetingEvent[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingEvent[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    saveParticipant(body?: MeetingEventParticipant | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/meeting/SaveParticipant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveParticipant(_response);
        });
    }

    protected processSaveParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @return Success
     */
    availability(propertyId?: string | undefined): Promise<CalendarEntity> {
        let url_ = this.baseUrl + "/api/property-page/availability?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAvailability(_response);
        });
    }

    protected processAvailability(response: Response): Promise<CalendarEntity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalendarEntity;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarEntity>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @param date (optional)
     * @return Success
     */
    availabilityForDate(propertyId?: string | undefined, date?: Date | undefined): Promise<CalendarEntity> {
        let url_ = this.baseUrl + "/api/property-page/availabilityForDate?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAvailabilityForDate(_response);
        });
    }

    protected processAvailabilityForDate(response: Response): Promise<CalendarEntity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalendarEntity;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarEntity>(null as any);
    }

    /**
     * Get search based property details based on query parameters that are outside of the property object
     * @param propertyId (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param pets (optional)
     * @param bookServices (optional)
     * @param discountCode (optional)
     * @param languageCurrencyKey (optional)
     * @param language (optional)
     * @param salesPartnerDetails_SalesPartner (optional)
     * @param salesPartnerDetails_BookingNumber (optional)
     * @param salesPartnerDetails_ServicePrices (optional)
     * @param salesPartnerDetails_RentalPrice (optional)
     * @param salesPartnerDetails_RentalCommission (optional)
     * @param salesPartnerDetails_CommissionPercentage (optional)
     * @param salesPartnerDetails_CancellationTerm (optional)
     * @param salesPartnerDetails_StayPrice (optional)
     * @param salesPartnerDetails_IsDirectApiBooking (optional)
     * @param salesPartnerDetails_IsAffiliateBooking (optional)
     * @param hybridDetails_RentalPrice (optional)
     * @param hybridDetails_HybridFeeDetails (optional)
     * @param throwErrorOnInvalidMandatoryGroupSelection (optional)
     * @param feeLanguage (optional)
     * @param addAdminAndInsuranceMarkupToServices (optional)
     * @return Success
     */
    searchDetails(adults: number, children: number, infants: number, propertyId?: string | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, pets?: number | undefined, bookServices?: { [key: string]: number; } | undefined, discountCode?: string | undefined, languageCurrencyKey?: string | undefined, language?: string | undefined, salesPartnerDetails_SalesPartner?: number | undefined, salesPartnerDetails_BookingNumber?: string | undefined, salesPartnerDetails_ServicePrices?: { [key: string]: number; } | undefined, salesPartnerDetails_RentalPrice?: number | undefined, salesPartnerDetails_RentalCommission?: number | undefined, salesPartnerDetails_CommissionPercentage?: number | undefined, salesPartnerDetails_CancellationTerm?: number | undefined, salesPartnerDetails_StayPrice?: number | undefined, salesPartnerDetails_IsDirectApiBooking?: boolean | undefined, salesPartnerDetails_IsAffiliateBooking?: boolean | undefined, hybridDetails_RentalPrice?: number | undefined, hybridDetails_HybridFeeDetails?: HybridFeeDetail[] | undefined, throwErrorOnInvalidMandatoryGroupSelection?: boolean | undefined, feeLanguage?: Language | undefined, addAdminAndInsuranceMarkupToServices?: boolean | undefined): Promise<SearchDetailsResponseModel> {
        let url_ = this.baseUrl + "/api/property-page/search-details?";
        if (adults === undefined || adults === null)
            throw new Error("The parameter 'adults' must be defined and cannot be null.");
        else
            url_ += "Adults=" + encodeURIComponent("" + adults) + "&";
        if (children === undefined || children === null)
            throw new Error("The parameter 'children' must be defined and cannot be null.");
        else
            url_ += "Children=" + encodeURIComponent("" + children) + "&";
        if (infants === undefined || infants === null)
            throw new Error("The parameter 'infants' must be defined and cannot be null.");
        else
            url_ += "Infants=" + encodeURIComponent("" + infants) + "&";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (pets === null)
            throw new Error("The parameter 'pets' cannot be null.");
        else if (pets !== undefined)
            url_ += "Pets=" + encodeURIComponent("" + pets) + "&";
        if (bookServices === null)
            throw new Error("The parameter 'bookServices' cannot be null.");
        else if (bookServices !== undefined)
            url_ += "BookServices=" + encodeURIComponent("" + bookServices) + "&";
        if (discountCode === null)
            throw new Error("The parameter 'discountCode' cannot be null.");
        else if (discountCode !== undefined)
            url_ += "DiscountCode=" + encodeURIComponent("" + discountCode) + "&";
        if (languageCurrencyKey === null)
            throw new Error("The parameter 'languageCurrencyKey' cannot be null.");
        else if (languageCurrencyKey !== undefined)
            url_ += "LanguageCurrencyKey=" + encodeURIComponent("" + languageCurrencyKey) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        if (salesPartnerDetails_SalesPartner === null)
            throw new Error("The parameter 'salesPartnerDetails_SalesPartner' cannot be null.");
        else if (salesPartnerDetails_SalesPartner !== undefined)
            url_ += "SalesPartnerDetails.SalesPartner=" + encodeURIComponent("" + salesPartnerDetails_SalesPartner) + "&";
        if (salesPartnerDetails_BookingNumber === null)
            throw new Error("The parameter 'salesPartnerDetails_BookingNumber' cannot be null.");
        else if (salesPartnerDetails_BookingNumber !== undefined)
            url_ += "SalesPartnerDetails.BookingNumber=" + encodeURIComponent("" + salesPartnerDetails_BookingNumber) + "&";
        if (salesPartnerDetails_ServicePrices === null)
            throw new Error("The parameter 'salesPartnerDetails_ServicePrices' cannot be null.");
        else if (salesPartnerDetails_ServicePrices !== undefined)
            url_ += "SalesPartnerDetails.ServicePrices=" + encodeURIComponent("" + salesPartnerDetails_ServicePrices) + "&";
        if (salesPartnerDetails_RentalPrice === null)
            throw new Error("The parameter 'salesPartnerDetails_RentalPrice' cannot be null.");
        else if (salesPartnerDetails_RentalPrice !== undefined)
            url_ += "SalesPartnerDetails.RentalPrice=" + encodeURIComponent("" + salesPartnerDetails_RentalPrice) + "&";
        if (salesPartnerDetails_RentalCommission === null)
            throw new Error("The parameter 'salesPartnerDetails_RentalCommission' cannot be null.");
        else if (salesPartnerDetails_RentalCommission !== undefined)
            url_ += "SalesPartnerDetails.RentalCommission=" + encodeURIComponent("" + salesPartnerDetails_RentalCommission) + "&";
        if (salesPartnerDetails_CommissionPercentage === null)
            throw new Error("The parameter 'salesPartnerDetails_CommissionPercentage' cannot be null.");
        else if (salesPartnerDetails_CommissionPercentage !== undefined)
            url_ += "SalesPartnerDetails.CommissionPercentage=" + encodeURIComponent("" + salesPartnerDetails_CommissionPercentage) + "&";
        if (salesPartnerDetails_CancellationTerm === null)
            throw new Error("The parameter 'salesPartnerDetails_CancellationTerm' cannot be null.");
        else if (salesPartnerDetails_CancellationTerm !== undefined)
            url_ += "SalesPartnerDetails.CancellationTerm=" + encodeURIComponent("" + salesPartnerDetails_CancellationTerm) + "&";
        if (salesPartnerDetails_StayPrice === null)
            throw new Error("The parameter 'salesPartnerDetails_StayPrice' cannot be null.");
        else if (salesPartnerDetails_StayPrice !== undefined)
            url_ += "SalesPartnerDetails.StayPrice=" + encodeURIComponent("" + salesPartnerDetails_StayPrice) + "&";
        if (salesPartnerDetails_IsDirectApiBooking === null)
            throw new Error("The parameter 'salesPartnerDetails_IsDirectApiBooking' cannot be null.");
        else if (salesPartnerDetails_IsDirectApiBooking !== undefined)
            url_ += "SalesPartnerDetails.IsDirectApiBooking=" + encodeURIComponent("" + salesPartnerDetails_IsDirectApiBooking) + "&";
        if (salesPartnerDetails_IsAffiliateBooking === null)
            throw new Error("The parameter 'salesPartnerDetails_IsAffiliateBooking' cannot be null.");
        else if (salesPartnerDetails_IsAffiliateBooking !== undefined)
            url_ += "SalesPartnerDetails.IsAffiliateBooking=" + encodeURIComponent("" + salesPartnerDetails_IsAffiliateBooking) + "&";
        if (hybridDetails_RentalPrice === null)
            throw new Error("The parameter 'hybridDetails_RentalPrice' cannot be null.");
        else if (hybridDetails_RentalPrice !== undefined)
            url_ += "HybridDetails.RentalPrice=" + encodeURIComponent("" + hybridDetails_RentalPrice) + "&";
        if (hybridDetails_HybridFeeDetails === null)
            throw new Error("The parameter 'hybridDetails_HybridFeeDetails' cannot be null.");
        else if (hybridDetails_HybridFeeDetails !== undefined)
            hybridDetails_HybridFeeDetails && hybridDetails_HybridFeeDetails.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "HybridDetails.HybridFeeDetails[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (throwErrorOnInvalidMandatoryGroupSelection === null)
            throw new Error("The parameter 'throwErrorOnInvalidMandatoryGroupSelection' cannot be null.");
        else if (throwErrorOnInvalidMandatoryGroupSelection !== undefined)
            url_ += "ThrowErrorOnInvalidMandatoryGroupSelection=" + encodeURIComponent("" + throwErrorOnInvalidMandatoryGroupSelection) + "&";
        if (feeLanguage === null)
            throw new Error("The parameter 'feeLanguage' cannot be null.");
        else if (feeLanguage !== undefined)
            url_ += "FeeLanguage=" + encodeURIComponent("" + feeLanguage) + "&";
        if (addAdminAndInsuranceMarkupToServices === null)
            throw new Error("The parameter 'addAdminAndInsuranceMarkupToServices' cannot be null.");
        else if (addAdminAndInsuranceMarkupToServices !== undefined)
            url_ += "AddAdminAndInsuranceMarkupToServices=" + encodeURIComponent("" + addAdminAndInsuranceMarkupToServices) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchDetails(_response);
        });
    }

    protected processSearchDetails(response: Response): Promise<SearchDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchDetailsResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDetailsResponseModel>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @return Success
     */
    propertyPage(propertyId?: string | undefined): Promise<PropertyResponseModel> {
        let url_ = this.baseUrl + "/api/property-page?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPropertyPage(_response);
        });
    }

    protected processPropertyPage(response: Response): Promise<PropertyResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PropertyResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyResponseModel>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param pets (optional)
     * @param bookServices (optional)
     * @param discountCode (optional)
     * @param languageCurrencyKey (optional)
     * @param language (optional)
     * @param salesPartnerDetails_SalesPartner (optional)
     * @param salesPartnerDetails_BookingNumber (optional)
     * @param salesPartnerDetails_ServicePrices (optional)
     * @param salesPartnerDetails_RentalPrice (optional)
     * @param salesPartnerDetails_RentalCommission (optional)
     * @param salesPartnerDetails_CommissionPercentage (optional)
     * @param salesPartnerDetails_CancellationTerm (optional)
     * @param salesPartnerDetails_StayPrice (optional)
     * @param salesPartnerDetails_IsDirectApiBooking (optional)
     * @param salesPartnerDetails_IsAffiliateBooking (optional)
     * @param hybridDetails_RentalPrice (optional)
     * @param hybridDetails_HybridFeeDetails (optional)
     * @param throwErrorOnInvalidMandatoryGroupSelection (optional)
     * @param feeLanguage (optional)
     * @param addAdminAndInsuranceMarkupToServices (optional)
     * @return Success
     */
    pricesAndFees(adults: number, children: number, infants: number, propertyId?: string | undefined, fromDate?: Date | undefined, toDate?: Date | undefined, pets?: number | undefined, bookServices?: { [key: string]: number; } | undefined, discountCode?: string | undefined, languageCurrencyKey?: string | undefined, language?: string | undefined, salesPartnerDetails_SalesPartner?: number | undefined, salesPartnerDetails_BookingNumber?: string | undefined, salesPartnerDetails_ServicePrices?: { [key: string]: number; } | undefined, salesPartnerDetails_RentalPrice?: number | undefined, salesPartnerDetails_RentalCommission?: number | undefined, salesPartnerDetails_CommissionPercentage?: number | undefined, salesPartnerDetails_CancellationTerm?: number | undefined, salesPartnerDetails_StayPrice?: number | undefined, salesPartnerDetails_IsDirectApiBooking?: boolean | undefined, salesPartnerDetails_IsAffiliateBooking?: boolean | undefined, hybridDetails_RentalPrice?: number | undefined, hybridDetails_HybridFeeDetails?: HybridFeeDetail[] | undefined, throwErrorOnInvalidMandatoryGroupSelection?: boolean | undefined, feeLanguage?: Language | undefined, addAdminAndInsuranceMarkupToServices?: boolean | undefined): Promise<ReservationPriceFeeResponse> {
        let url_ = this.baseUrl + "/api/property-page/prices-and-fees?";
        if (adults === undefined || adults === null)
            throw new Error("The parameter 'adults' must be defined and cannot be null.");
        else
            url_ += "Adults=" + encodeURIComponent("" + adults) + "&";
        if (children === undefined || children === null)
            throw new Error("The parameter 'children' must be defined and cannot be null.");
        else
            url_ += "Children=" + encodeURIComponent("" + children) + "&";
        if (infants === undefined || infants === null)
            throw new Error("The parameter 'infants' must be defined and cannot be null.");
        else
            url_ += "Infants=" + encodeURIComponent("" + infants) + "&";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (pets === null)
            throw new Error("The parameter 'pets' cannot be null.");
        else if (pets !== undefined)
            url_ += "Pets=" + encodeURIComponent("" + pets) + "&";
        if (bookServices === null)
            throw new Error("The parameter 'bookServices' cannot be null.");
        else if (bookServices !== undefined)
            url_ += "BookServices=" + encodeURIComponent("" + bookServices) + "&";
        if (discountCode === null)
            throw new Error("The parameter 'discountCode' cannot be null.");
        else if (discountCode !== undefined)
            url_ += "DiscountCode=" + encodeURIComponent("" + discountCode) + "&";
        if (languageCurrencyKey === null)
            throw new Error("The parameter 'languageCurrencyKey' cannot be null.");
        else if (languageCurrencyKey !== undefined)
            url_ += "LanguageCurrencyKey=" + encodeURIComponent("" + languageCurrencyKey) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        if (salesPartnerDetails_SalesPartner === null)
            throw new Error("The parameter 'salesPartnerDetails_SalesPartner' cannot be null.");
        else if (salesPartnerDetails_SalesPartner !== undefined)
            url_ += "SalesPartnerDetails.SalesPartner=" + encodeURIComponent("" + salesPartnerDetails_SalesPartner) + "&";
        if (salesPartnerDetails_BookingNumber === null)
            throw new Error("The parameter 'salesPartnerDetails_BookingNumber' cannot be null.");
        else if (salesPartnerDetails_BookingNumber !== undefined)
            url_ += "SalesPartnerDetails.BookingNumber=" + encodeURIComponent("" + salesPartnerDetails_BookingNumber) + "&";
        if (salesPartnerDetails_ServicePrices === null)
            throw new Error("The parameter 'salesPartnerDetails_ServicePrices' cannot be null.");
        else if (salesPartnerDetails_ServicePrices !== undefined)
            url_ += "SalesPartnerDetails.ServicePrices=" + encodeURIComponent("" + salesPartnerDetails_ServicePrices) + "&";
        if (salesPartnerDetails_RentalPrice === null)
            throw new Error("The parameter 'salesPartnerDetails_RentalPrice' cannot be null.");
        else if (salesPartnerDetails_RentalPrice !== undefined)
            url_ += "SalesPartnerDetails.RentalPrice=" + encodeURIComponent("" + salesPartnerDetails_RentalPrice) + "&";
        if (salesPartnerDetails_RentalCommission === null)
            throw new Error("The parameter 'salesPartnerDetails_RentalCommission' cannot be null.");
        else if (salesPartnerDetails_RentalCommission !== undefined)
            url_ += "SalesPartnerDetails.RentalCommission=" + encodeURIComponent("" + salesPartnerDetails_RentalCommission) + "&";
        if (salesPartnerDetails_CommissionPercentage === null)
            throw new Error("The parameter 'salesPartnerDetails_CommissionPercentage' cannot be null.");
        else if (salesPartnerDetails_CommissionPercentage !== undefined)
            url_ += "SalesPartnerDetails.CommissionPercentage=" + encodeURIComponent("" + salesPartnerDetails_CommissionPercentage) + "&";
        if (salesPartnerDetails_CancellationTerm === null)
            throw new Error("The parameter 'salesPartnerDetails_CancellationTerm' cannot be null.");
        else if (salesPartnerDetails_CancellationTerm !== undefined)
            url_ += "SalesPartnerDetails.CancellationTerm=" + encodeURIComponent("" + salesPartnerDetails_CancellationTerm) + "&";
        if (salesPartnerDetails_StayPrice === null)
            throw new Error("The parameter 'salesPartnerDetails_StayPrice' cannot be null.");
        else if (salesPartnerDetails_StayPrice !== undefined)
            url_ += "SalesPartnerDetails.StayPrice=" + encodeURIComponent("" + salesPartnerDetails_StayPrice) + "&";
        if (salesPartnerDetails_IsDirectApiBooking === null)
            throw new Error("The parameter 'salesPartnerDetails_IsDirectApiBooking' cannot be null.");
        else if (salesPartnerDetails_IsDirectApiBooking !== undefined)
            url_ += "SalesPartnerDetails.IsDirectApiBooking=" + encodeURIComponent("" + salesPartnerDetails_IsDirectApiBooking) + "&";
        if (salesPartnerDetails_IsAffiliateBooking === null)
            throw new Error("The parameter 'salesPartnerDetails_IsAffiliateBooking' cannot be null.");
        else if (salesPartnerDetails_IsAffiliateBooking !== undefined)
            url_ += "SalesPartnerDetails.IsAffiliateBooking=" + encodeURIComponent("" + salesPartnerDetails_IsAffiliateBooking) + "&";
        if (hybridDetails_RentalPrice === null)
            throw new Error("The parameter 'hybridDetails_RentalPrice' cannot be null.");
        else if (hybridDetails_RentalPrice !== undefined)
            url_ += "HybridDetails.RentalPrice=" + encodeURIComponent("" + hybridDetails_RentalPrice) + "&";
        if (hybridDetails_HybridFeeDetails === null)
            throw new Error("The parameter 'hybridDetails_HybridFeeDetails' cannot be null.");
        else if (hybridDetails_HybridFeeDetails !== undefined)
            hybridDetails_HybridFeeDetails && hybridDetails_HybridFeeDetails.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "HybridDetails.HybridFeeDetails[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (throwErrorOnInvalidMandatoryGroupSelection === null)
            throw new Error("The parameter 'throwErrorOnInvalidMandatoryGroupSelection' cannot be null.");
        else if (throwErrorOnInvalidMandatoryGroupSelection !== undefined)
            url_ += "ThrowErrorOnInvalidMandatoryGroupSelection=" + encodeURIComponent("" + throwErrorOnInvalidMandatoryGroupSelection) + "&";
        if (feeLanguage === null)
            throw new Error("The parameter 'feeLanguage' cannot be null.");
        else if (feeLanguage !== undefined)
            url_ += "FeeLanguage=" + encodeURIComponent("" + feeLanguage) + "&";
        if (addAdminAndInsuranceMarkupToServices === null)
            throw new Error("The parameter 'addAdminAndInsuranceMarkupToServices' cannot be null.");
        else if (addAdminAndInsuranceMarkupToServices !== undefined)
            url_ += "AddAdminAndInsuranceMarkupToServices=" + encodeURIComponent("" + addAdminAndInsuranceMarkupToServices) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPricesAndFees(_response);
        });
    }

    protected processPricesAndFees(response: Response): Promise<ReservationPriceFeeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReservationPriceFeeResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservationPriceFeeResponse>(null as any);
    }

    /**
     * Main Search endpoint
     * @param propertyIds (optional)
     * @param initialSearch (optional)
     * @param fieldList (optional)
     * @param fromIndex (optional)
     * @param size (optional)
     * @param areaId (optional)
     * @param areaName (optional)
     * @param sortMethod (optional)
     * @param toDate (optional)
     * @param fromDate (optional)
     * @param fromPrice (optional)
     * @param toPrice (optional)
     * @param flexibleDates (optional)
     * @param salesPartnerIds (optional)
     * @param incrementalUpdateTimestamp (optional)
     * @param isFlexRent (optional)
     * @param aC (optional)
     * @param propertyType (optional)
     * @param dishwasher (optional)
     * @param washingMachine (optional)
     * @param tv (optional)
     * @param internet (optional)
     * @param wheelchairFriendly (optional)
     * @param eVChargingStation (optional)
     * @param indoorPool (optional)
     * @param spa (optional)
     * @param hotTub (optional)
     * @param firePlace (optional)
     * @param barbecue (optional)
     * @param coffeeMachine (optional)
     * @param petsAllowed (optional)
     * @param smokingAllowed (optional)
     * @param adults (optional)
     * @param children (optional)
     * @param infants (optional)
     * @param pets (optional)
     * @param fromBedrooms (optional)
     * @param toBedrooms (optional)
     * @param bathrooms (optional)
     * @param themeId (optional)
     * @param distanceToWater (optional)
     * @param geoBoundingBox_SouthWestLat (optional)
     * @param geoBoundingBox_SouthWestLon (optional)
     * @param geoBoundingBox_NorthEastLat (optional)
     * @param geoBoundingBox_NorthEastLon (optional)
     * @param outdoorPool (optional)
     * @param hasLastMinuteAvailability (optional)
     * @param boostLastMinuteAvailability (optional)
     * @param germanChannels (optional)
     * @param dryer (optional)
     * @param privateOwner (optional)
     * @param scandinavianChannels (optional)
     * @param chromeCast (optional)
     * @param minAverageReviewsAsBoost (optional)
     * @param cancellationTemplateIds (optional)
     * @param sauna (optional)
     * @return Success
     */
    search(propertyIds?: string[] | undefined, initialSearch?: boolean | undefined, fieldList?: string[] | undefined, fromIndex?: number | undefined, size?: number | undefined, areaId?: number | undefined, areaName?: string | undefined, sortMethod?: SortingMethods | undefined, toDate?: Date | undefined, fromDate?: Date | undefined, fromPrice?: number | undefined, toPrice?: number | undefined, flexibleDates?: number | undefined, salesPartnerIds?: number[] | undefined, incrementalUpdateTimestamp?: Date | undefined, isFlexRent?: boolean | undefined, aC?: boolean | undefined, propertyType?: number | undefined, dishwasher?: boolean | undefined, washingMachine?: boolean | undefined, tv?: boolean | undefined, internet?: boolean | undefined, wheelchairFriendly?: boolean | undefined, eVChargingStation?: boolean | undefined, indoorPool?: boolean | undefined, spa?: boolean | undefined, hotTub?: boolean | undefined, firePlace?: boolean | undefined, barbecue?: boolean | undefined, coffeeMachine?: boolean | undefined, petsAllowed?: boolean | undefined, smokingAllowed?: boolean | undefined, adults?: number | undefined, children?: number | undefined, infants?: number | undefined, pets?: number | undefined, fromBedrooms?: number | undefined, toBedrooms?: number | undefined, bathrooms?: number | undefined, themeId?: number | undefined, distanceToWater?: WaterDistance | undefined, geoBoundingBox_SouthWestLat?: number | undefined, geoBoundingBox_SouthWestLon?: number | undefined, geoBoundingBox_NorthEastLat?: number | undefined, geoBoundingBox_NorthEastLon?: number | undefined, outdoorPool?: boolean | undefined, hasLastMinuteAvailability?: boolean | undefined, boostLastMinuteAvailability?: boolean | undefined, germanChannels?: boolean | undefined, dryer?: boolean | undefined, privateOwner?: boolean | undefined, scandinavianChannels?: boolean | undefined, chromeCast?: boolean | undefined, minAverageReviewsAsBoost?: number | undefined, cancellationTemplateIds?: number[] | undefined, sauna?: boolean | undefined): Promise<SearchResponseModel> {
        let url_ = this.baseUrl + "/api/search?";
        if (propertyIds === null)
            throw new Error("The parameter 'propertyIds' cannot be null.");
        else if (propertyIds !== undefined)
            propertyIds && propertyIds.forEach(item => { url_ += "PropertyIds=" + encodeURIComponent("" + item) + "&"; });
        if (initialSearch === null)
            throw new Error("The parameter 'initialSearch' cannot be null.");
        else if (initialSearch !== undefined)
            url_ += "InitialSearch=" + encodeURIComponent("" + initialSearch) + "&";
        if (fieldList === null)
            throw new Error("The parameter 'fieldList' cannot be null.");
        else if (fieldList !== undefined)
            fieldList && fieldList.forEach(item => { url_ += "FieldList=" + encodeURIComponent("" + item) + "&"; });
        if (fromIndex === null)
            throw new Error("The parameter 'fromIndex' cannot be null.");
        else if (fromIndex !== undefined)
            url_ += "FromIndex=" + encodeURIComponent("" + fromIndex) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (areaId === null)
            throw new Error("The parameter 'areaId' cannot be null.");
        else if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&";
        if (areaName === null)
            throw new Error("The parameter 'areaName' cannot be null.");
        else if (areaName !== undefined)
            url_ += "AreaName=" + encodeURIComponent("" + areaName) + "&";
        if (sortMethod === null)
            throw new Error("The parameter 'sortMethod' cannot be null.");
        else if (sortMethod !== undefined)
            url_ += "SortMethod=" + encodeURIComponent("" + sortMethod) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (fromPrice === null)
            throw new Error("The parameter 'fromPrice' cannot be null.");
        else if (fromPrice !== undefined)
            url_ += "FromPrice=" + encodeURIComponent("" + fromPrice) + "&";
        if (toPrice === null)
            throw new Error("The parameter 'toPrice' cannot be null.");
        else if (toPrice !== undefined)
            url_ += "ToPrice=" + encodeURIComponent("" + toPrice) + "&";
        if (flexibleDates === null)
            throw new Error("The parameter 'flexibleDates' cannot be null.");
        else if (flexibleDates !== undefined)
            url_ += "FlexibleDates=" + encodeURIComponent("" + flexibleDates) + "&";
        if (salesPartnerIds === null)
            throw new Error("The parameter 'salesPartnerIds' cannot be null.");
        else if (salesPartnerIds !== undefined)
            salesPartnerIds && salesPartnerIds.forEach(item => { url_ += "SalesPartnerIds=" + encodeURIComponent("" + item) + "&"; });
        if (incrementalUpdateTimestamp === null)
            throw new Error("The parameter 'incrementalUpdateTimestamp' cannot be null.");
        else if (incrementalUpdateTimestamp !== undefined)
            url_ += "IncrementalUpdateTimestamp=" + encodeURIComponent(incrementalUpdateTimestamp ? "" + incrementalUpdateTimestamp.toISOString() : "") + "&";
        if (isFlexRent === null)
            throw new Error("The parameter 'isFlexRent' cannot be null.");
        else if (isFlexRent !== undefined)
            url_ += "IsFlexRent=" + encodeURIComponent("" + isFlexRent) + "&";
        if (aC === null)
            throw new Error("The parameter 'aC' cannot be null.");
        else if (aC !== undefined)
            url_ += "AC=" + encodeURIComponent("" + aC) + "&";
        if (propertyType === null)
            throw new Error("The parameter 'propertyType' cannot be null.");
        else if (propertyType !== undefined)
            url_ += "PropertyType=" + encodeURIComponent("" + propertyType) + "&";
        if (dishwasher === null)
            throw new Error("The parameter 'dishwasher' cannot be null.");
        else if (dishwasher !== undefined)
            url_ += "Dishwasher=" + encodeURIComponent("" + dishwasher) + "&";
        if (washingMachine === null)
            throw new Error("The parameter 'washingMachine' cannot be null.");
        else if (washingMachine !== undefined)
            url_ += "WashingMachine=" + encodeURIComponent("" + washingMachine) + "&";
        if (tv === null)
            throw new Error("The parameter 'tv' cannot be null.");
        else if (tv !== undefined)
            url_ += "Tv=" + encodeURIComponent("" + tv) + "&";
        if (internet === null)
            throw new Error("The parameter 'internet' cannot be null.");
        else if (internet !== undefined)
            url_ += "Internet=" + encodeURIComponent("" + internet) + "&";
        if (wheelchairFriendly === null)
            throw new Error("The parameter 'wheelchairFriendly' cannot be null.");
        else if (wheelchairFriendly !== undefined)
            url_ += "WheelchairFriendly=" + encodeURIComponent("" + wheelchairFriendly) + "&";
        if (eVChargingStation === null)
            throw new Error("The parameter 'eVChargingStation' cannot be null.");
        else if (eVChargingStation !== undefined)
            url_ += "EVChargingStation=" + encodeURIComponent("" + eVChargingStation) + "&";
        if (indoorPool === null)
            throw new Error("The parameter 'indoorPool' cannot be null.");
        else if (indoorPool !== undefined)
            url_ += "IndoorPool=" + encodeURIComponent("" + indoorPool) + "&";
        if (spa === null)
            throw new Error("The parameter 'spa' cannot be null.");
        else if (spa !== undefined)
            url_ += "Spa=" + encodeURIComponent("" + spa) + "&";
        if (hotTub === null)
            throw new Error("The parameter 'hotTub' cannot be null.");
        else if (hotTub !== undefined)
            url_ += "HotTub=" + encodeURIComponent("" + hotTub) + "&";
        if (firePlace === null)
            throw new Error("The parameter 'firePlace' cannot be null.");
        else if (firePlace !== undefined)
            url_ += "FirePlace=" + encodeURIComponent("" + firePlace) + "&";
        if (barbecue === null)
            throw new Error("The parameter 'barbecue' cannot be null.");
        else if (barbecue !== undefined)
            url_ += "Barbecue=" + encodeURIComponent("" + barbecue) + "&";
        if (coffeeMachine === null)
            throw new Error("The parameter 'coffeeMachine' cannot be null.");
        else if (coffeeMachine !== undefined)
            url_ += "CoffeeMachine=" + encodeURIComponent("" + coffeeMachine) + "&";
        if (petsAllowed === null)
            throw new Error("The parameter 'petsAllowed' cannot be null.");
        else if (petsAllowed !== undefined)
            url_ += "PetsAllowed=" + encodeURIComponent("" + petsAllowed) + "&";
        if (smokingAllowed === null)
            throw new Error("The parameter 'smokingAllowed' cannot be null.");
        else if (smokingAllowed !== undefined)
            url_ += "SmokingAllowed=" + encodeURIComponent("" + smokingAllowed) + "&";
        if (adults === null)
            throw new Error("The parameter 'adults' cannot be null.");
        else if (adults !== undefined)
            url_ += "Adults=" + encodeURIComponent("" + adults) + "&";
        if (children === null)
            throw new Error("The parameter 'children' cannot be null.");
        else if (children !== undefined)
            url_ += "Children=" + encodeURIComponent("" + children) + "&";
        if (infants === null)
            throw new Error("The parameter 'infants' cannot be null.");
        else if (infants !== undefined)
            url_ += "Infants=" + encodeURIComponent("" + infants) + "&";
        if (pets === null)
            throw new Error("The parameter 'pets' cannot be null.");
        else if (pets !== undefined)
            url_ += "Pets=" + encodeURIComponent("" + pets) + "&";
        if (fromBedrooms === null)
            throw new Error("The parameter 'fromBedrooms' cannot be null.");
        else if (fromBedrooms !== undefined)
            url_ += "fromBedrooms=" + encodeURIComponent("" + fromBedrooms) + "&";
        if (toBedrooms === null)
            throw new Error("The parameter 'toBedrooms' cannot be null.");
        else if (toBedrooms !== undefined)
            url_ += "toBedrooms=" + encodeURIComponent("" + toBedrooms) + "&";
        if (bathrooms === null)
            throw new Error("The parameter 'bathrooms' cannot be null.");
        else if (bathrooms !== undefined)
            url_ += "Bathrooms=" + encodeURIComponent("" + bathrooms) + "&";
        if (themeId === null)
            throw new Error("The parameter 'themeId' cannot be null.");
        else if (themeId !== undefined)
            url_ += "ThemeId=" + encodeURIComponent("" + themeId) + "&";
        if (distanceToWater === null)
            throw new Error("The parameter 'distanceToWater' cannot be null.");
        else if (distanceToWater !== undefined)
            url_ += "DistanceToWater=" + encodeURIComponent("" + distanceToWater) + "&";
        if (geoBoundingBox_SouthWestLat === null)
            throw new Error("The parameter 'geoBoundingBox_SouthWestLat' cannot be null.");
        else if (geoBoundingBox_SouthWestLat !== undefined)
            url_ += "GeoBoundingBox.SouthWestLat=" + encodeURIComponent("" + geoBoundingBox_SouthWestLat) + "&";
        if (geoBoundingBox_SouthWestLon === null)
            throw new Error("The parameter 'geoBoundingBox_SouthWestLon' cannot be null.");
        else if (geoBoundingBox_SouthWestLon !== undefined)
            url_ += "GeoBoundingBox.SouthWestLon=" + encodeURIComponent("" + geoBoundingBox_SouthWestLon) + "&";
        if (geoBoundingBox_NorthEastLat === null)
            throw new Error("The parameter 'geoBoundingBox_NorthEastLat' cannot be null.");
        else if (geoBoundingBox_NorthEastLat !== undefined)
            url_ += "GeoBoundingBox.NorthEastLat=" + encodeURIComponent("" + geoBoundingBox_NorthEastLat) + "&";
        if (geoBoundingBox_NorthEastLon === null)
            throw new Error("The parameter 'geoBoundingBox_NorthEastLon' cannot be null.");
        else if (geoBoundingBox_NorthEastLon !== undefined)
            url_ += "GeoBoundingBox.NorthEastLon=" + encodeURIComponent("" + geoBoundingBox_NorthEastLon) + "&";
        if (outdoorPool === null)
            throw new Error("The parameter 'outdoorPool' cannot be null.");
        else if (outdoorPool !== undefined)
            url_ += "OutdoorPool=" + encodeURIComponent("" + outdoorPool) + "&";
        if (hasLastMinuteAvailability === null)
            throw new Error("The parameter 'hasLastMinuteAvailability' cannot be null.");
        else if (hasLastMinuteAvailability !== undefined)
            url_ += "HasLastMinuteAvailability=" + encodeURIComponent("" + hasLastMinuteAvailability) + "&";
        if (boostLastMinuteAvailability === null)
            throw new Error("The parameter 'boostLastMinuteAvailability' cannot be null.");
        else if (boostLastMinuteAvailability !== undefined)
            url_ += "BoostLastMinuteAvailability=" + encodeURIComponent("" + boostLastMinuteAvailability) + "&";
        if (germanChannels === null)
            throw new Error("The parameter 'germanChannels' cannot be null.");
        else if (germanChannels !== undefined)
            url_ += "GermanChannels=" + encodeURIComponent("" + germanChannels) + "&";
        if (dryer === null)
            throw new Error("The parameter 'dryer' cannot be null.");
        else if (dryer !== undefined)
            url_ += "Dryer=" + encodeURIComponent("" + dryer) + "&";
        if (privateOwner === null)
            throw new Error("The parameter 'privateOwner' cannot be null.");
        else if (privateOwner !== undefined)
            url_ += "PrivateOwner=" + encodeURIComponent("" + privateOwner) + "&";
        if (scandinavianChannels === null)
            throw new Error("The parameter 'scandinavianChannels' cannot be null.");
        else if (scandinavianChannels !== undefined)
            url_ += "ScandinavianChannels=" + encodeURIComponent("" + scandinavianChannels) + "&";
        if (chromeCast === null)
            throw new Error("The parameter 'chromeCast' cannot be null.");
        else if (chromeCast !== undefined)
            url_ += "ChromeCast=" + encodeURIComponent("" + chromeCast) + "&";
        if (minAverageReviewsAsBoost === null)
            throw new Error("The parameter 'minAverageReviewsAsBoost' cannot be null.");
        else if (minAverageReviewsAsBoost !== undefined)
            url_ += "MinAverageReviewsAsBoost=" + encodeURIComponent("" + minAverageReviewsAsBoost) + "&";
        if (cancellationTemplateIds === null)
            throw new Error("The parameter 'cancellationTemplateIds' cannot be null.");
        else if (cancellationTemplateIds !== undefined)
            cancellationTemplateIds && cancellationTemplateIds.forEach(item => { url_ += "CancellationTemplateIds=" + encodeURIComponent("" + item) + "&"; });
        if (sauna === null)
            throw new Error("The parameter 'sauna' cannot be null.");
        else if (sauna !== undefined)
            url_ += "Sauna=" + encodeURIComponent("" + sauna) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SearchResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResponseModel>(null as any);
    }

    /**
     * @param areaId (optional)
     * @param themeId (optional)
     * @return Success
     */
    relatedDestinations(areaId?: number | undefined, themeId?: number | undefined): Promise<RelatedDestinationModel> {
        let url_ = this.baseUrl + "/api/search/related-destinations?";
        if (areaId === null)
            throw new Error("The parameter 'areaId' cannot be null.");
        else if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&";
        if (themeId === null)
            throw new Error("The parameter 'themeId' cannot be null.");
        else if (themeId !== undefined)
            url_ += "themeId=" + encodeURIComponent("" + themeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRelatedDestinations(_response);
        });
    }

    protected processRelatedDestinations(response: Response): Promise<RelatedDestinationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RelatedDestinationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelatedDestinationModel>(null as any);
    }

    /**
     * @param propertyId (optional)
     * @return Success
     */
    propertyRelatedDestinations(propertyId?: string | undefined): Promise<RelatedDestinationModel> {
        let url_ = this.baseUrl + "/api/search/property-related-destinations?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPropertyRelatedDestinations(_response);
        });
    }

    protected processPropertyRelatedDestinations(response: Response): Promise<RelatedDestinationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RelatedDestinationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelatedDestinationModel>(null as any);
    }

    /**
     * @return Success
     */
    sortOptions(): Promise<SortOptionsResponseModel> {
        let url_ = this.baseUrl + "/api/search/sort-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSortOptions(_response);
        });
    }

    protected processSortOptions(response: Response): Promise<SortOptionsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SortOptionsResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SortOptionsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    filterOptions(): Promise<FilterOptionsResponseModel> {
        let url_ = this.baseUrl + "/api/search/filter-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFilterOptions(_response);
        });
    }

    protected processFilterOptions(response: Response): Promise<FilterOptionsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FilterOptionsResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterOptionsResponseModel>(null as any);
    }

    /**
     * @param query (optional)
     * @return Success
     */
    autocomplete(query?: string | undefined): Promise<SearchItem[]> {
        let url_ = this.baseUrl + "/api/search/autocomplete?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAutocomplete(_response);
        });
    }

    protected processAutocomplete(response: Response): Promise<SearchItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchItem[]>(null as any);
    }

    /**
     * @param areaId (optional)
     * @param month (optional)
     * @param year (optional)
     * @param timeZoneOffsetMinutes (optional)
     * @return Success
     */
    calendarCss(areaId?: number | undefined, month?: number | undefined, year?: number | undefined, timeZoneOffsetMinutes?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/search/calendar-css?";
        if (areaId === null)
            throw new Error("The parameter 'areaId' cannot be null.");
        else if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (timeZoneOffsetMinutes === null)
            throw new Error("The parameter 'timeZoneOffsetMinutes' cannot be null.");
        else if (timeZoneOffsetMinutes !== undefined)
            url_ += "timeZoneOffsetMinutes=" + encodeURIComponent("" + timeZoneOffsetMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalendarCss(_response);
        });
    }

    protected processCalendarCss(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get translations for a list of textIds
     * @param textIds (optional)
     * @return Success
     */
    getTranslations(textIds?: number[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/translation/GetTranslations?";
        if (textIds === null)
            throw new Error("The parameter 'textIds' cannot be null.");
        else if (textIds !== undefined)
            textIds && textIds.forEach(item => { url_ += "textIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTranslations(_response);
        });
    }

    protected processGetTranslations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get languages that should have translations
     * @return Success
     */
    getLanguagesForTranslation(): Promise<LanguageInfo[]> {
        let url_ = this.baseUrl + "/api/translation/GetLanguagesForTranslation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLanguagesForTranslation(_response);
        });
    }

    protected processGetLanguagesForTranslation(response: Response): Promise<LanguageInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LanguageInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageInfo[]>(null as any);
    }
}

export interface AlternativeSearch {
    filterOption?: string | undefined;
    expectedResultCount?: number;
    areaId?: number | undefined;
}

export interface AppliedDiscount {
    discount?: number;
    type?: DiscountTypes;
    discountPercent?: number | undefined;
    applyOnServices?: boolean | undefined;
    serviceDiscount?: number | undefined;
}

export interface AppliedDiscountCode {
    code?: string | undefined;
    discountPercent?: number;
    discount?: number;
    currency?: string | undefined;
}

export interface AreaLink {
    areaId?: number;
    areaName?: string | undefined;
    url?: string | undefined;
}

export interface ArrivalInformation {
    isVisible?: boolean;
    highlightedTitle?: string | undefined;
    text?: string | undefined;
    address?: string | undefined;
    arrivalTime?: string | undefined;
}

export interface BankTransferInformation {
    active?: boolean;
    instructions?: BankTransferInstructions;
}

export interface BankTransferInstructions {
    reference?: string | undefined;
    amountRemainingWithCurrency?: string | undefined;
    financialAddresses?: FinancialAddress[] | undefined;
    hostedInstructionsUrl?: string | undefined;
}

export interface BookedFee {
    name?: string | undefined;
    price?: number | undefined;
    currency?: string | undefined;
    priceInBookingCurrency?: string | undefined;
    included?: boolean;
    tooltip?: string | undefined;
}

export interface BookingContactDetails {
    guest?: ContactDetail;
    ownerName?: string | undefined;
}

export interface BookingCreatePaymentResponseModel {
    clientSecret?: string | undefined;
}

export interface BookingDetails {
    period?: Period;
    guests?: Guests;
    bookedFees?: BookedFee[] | undefined;
    totalPrice?: TotalPrice;
    usageCostsAfterDeparture?: UsageCost[] | undefined;
    usageCostsOnLocation?: UsageCost[] | undefined;
    cancellationInsurancePolicyNumber?: string | undefined;
    appliedDiscountCode?: AppliedDiscountCode;
}

export enum BookingErrors {
    _754 = 754,
    _1200 = 1200,
    _1346 = 1346,
    _1422 = 1422,
    _1451 = 1451,
    _1459 = 1459,
    _1510 = 1510,
    _1512 = 1512,
    _1513 = 1513,
    _1516 = 1516,
    _2251 = 2251,
    _2354 = 2354,
    _3493 = 3493,
    _3495 = 3495,
    _3496 = 3496,
    _3497 = 3497,
    _3498 = 3498,
    _3499 = 3499,
    _3501 = 3501,
    _3508 = 3508,
    _3643 = 3643,
    _3671 = 3671,
    _6518 = 6518,
    _6716 = 6716,
    _6717 = 6717,
    _6718 = 6718,
    _6719 = 6719,
    _6720 = 6720,
    _6729 = 6729,
    _6977 = 6977,
    _6978 = 6978,
    _6979 = 6979,
    _6980 = 6980,
    _6981 = 6981,
    _6985 = 6985,
    _6989 = 6989,
    _6990 = 6990,
    _6991 = 6991,
    _6992 = 6992,
    _6993 = 6993,
    _6994 = 6994,
    _7000 = 7000,
    _7014 = 7014,
    _7015 = 7015,
    _7016 = 7016,
    _7017 = 7017,
    _7078 = 7078,
    _7120 = 7120,
    _8402 = 8402,
    _8403 = 8403,
    _14067 = 14067,
    _14071 = 14071,
    _14072 = 14072,
    _14078 = 14078,
}

export interface BookingFlowResponseModel {
    property?: Property;
    mandatoryFees?: MandatoryFee[] | undefined;
    optionalFees?: OptionalFee[] | undefined;
    usageCostsAfterDeparture?: UsageCost[] | undefined;
    usageCostsOnLocation?: UsageCost[] | undefined;
    mandatoryChoiceFees?: MandatoryChoiceFee[] | undefined;
    totalPrice?: TotalPrice;
    paymentOptions?: PaymentOption[] | undefined;
    nights?: number;
    countries?: CountryOption[] | undefined;
    defaultCountryCode?: string | undefined;
    termsAndConditions?: string | undefined;
    privacyPolicy?: string | undefined;
    errors?: ReservationError[] | undefined;
    flexiblePaymentTooltip?: string | undefined;
    bookingStartedTrackingData?: BookingStartedTrackingData;
    paymentMethods?: string[] | undefined;
    commissionPercentage?: number;
    checkInTime?: string | undefined;
    checkOutTime?: string | undefined;
}

export interface BookingRequest {
    personalDetails?: PersonalDetails;
    selectedOptions?: SelectedBookingOption[] | undefined;
    paymentOption?: PaymentOptions;
    subscribeToNewsLetters?: boolean;
    priceAndFeesRequest?: PriceAndFeesRequest;
}

export interface BookingResponseModel {
    agencyBookingNumber?: string | undefined;
    errors?: ReservationError[] | undefined;
    property?: Property;
    generalInformation?: GeneralInformation;
    paymentInformation?: PaymentInformation;
    bookingStatus?: BookingStatus;
    bookingStatusSuccess?: BookingStatus;
    bookingContactDetails?: BookingContactDetails;
    bookingDetails?: BookingDetails;
    arrivalInformation?: ArrivalInformation;
    flexiblePaymentTooltip?: string | undefined;
    trackingData?: TrackingData;
    bookingSettlementDetails?: BookingSettlementDetails[] | undefined;
    gtmData?: GtmData;
    consumptionDetails?: ConsumptionDetails;
    shouldCurrentRateBePaidAtSalesPartner?: boolean;
    salesPartnerName?: string | undefined;
}

export interface BookingSettlementDetails {
    consumptionCosts?: SettlementCost[] | undefined;
    damageCosts?: SettlementCost[] | undefined;
    extraServicesCosts?: SettlementCost[] | undefined;
    extraDiscounts?: SettlementCost[] | undefined;
    otherCosts?: SettlementCost[] | undefined;
    afterDeparturePriceSum?: number | undefined;
    afterDepartureCurrency?: string | undefined;
    depositAmount?: number | undefined;
    depositCurrency?: string | undefined;
    totalRefund?: SettlementTotal;
    totalPayment?: SettlementTotal;
}

export interface BookingStartedTrackingData {
    price?: number;
    area?: string | undefined;
    currency?: string | undefined;
    brand?: string | undefined;
    country?: string | undefined;
    region?: string | undefined;
    city?: string | undefined;
}

export interface BookingStatus {
    type?: BookingStatusType;
    highlightedTitle?: string | undefined;
    text?: string | undefined;
    isPartiallyPaid?: boolean;
}

export enum BookingStatusType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export interface BoolFacilities {
    headline?: string | undefined;
    items?: string[] | undefined;
}

/** Current Language */
export interface BreadcrumbItem {
    name?: string | undefined;
    link?: string | undefined;
}

export interface CalendarEntity {
    availableDates?: string[] | undefined;
    checkinDates?: string[] | undefined;
    checkoutDates?: string[] | undefined;
}

export interface CategoryFacilities {
    facilities?: CategoryFacility[] | undefined;
}

export interface CategoryFacility {
    headline?: string | undefined;
    text?: string | undefined;
    iconName?: string | undefined;
}

export interface ConsumptionDetails {
    canEdit?: boolean;
    hasAutomaticElectricityReading?: boolean;
    consumptionEntries?: ConsumptionEntry[] | undefined;
}

export interface ConsumptionEntry {
    name?: string | undefined;
    arrivalValue?: number;
    departureValue?: number;
    unit?: string | undefined;
    serviceId?: number;
}

export interface ContactDetail {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    country?: string | undefined;
}

export interface Coordinate {
    latitude?: number;
    longitude?: number;
    zoomLevel?: number;
}

export interface CountryOption {
    countryCode?: string | undefined;
    name?: string | undefined;
}

export enum Currency {
    _1 = 1,
    _5 = 5,
    _7 = 7,
    _13 = 13,
    _18 = 18,
    _71 = 71,
}

export enum DbAnalyticEventTypes {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export interface DbLiveCurrency {
    currency?: Currency;
    currencyId?: number;
    currencyCode?: string | undefined;
    currencySign?: string | undefined;
    price?: number;
}

export enum DbServiceUnits {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
}

export interface Descriptions {
    shortDescription?: string | undefined;
    longDescription?: string | undefined;
}

export enum DiscountTypes {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export interface DistanceFacilities {
    headline?: string | undefined;
    items?: string[] | undefined;
}

export interface FacilitiesList {
    categoryFacilities?: CategoryFacilities;
    keyFacilities?: KeyFacilities;
    allFacilities?: ThemeFacilities[] | undefined;
    previewFacilities?: Facility[] | undefined;
}

export interface Facility {
    items?: string[] | undefined;
    value?: string | undefined;
    priority?: number;
}

export interface FilterOptionBool {
    name?: string | undefined;
    options?: OptionBool[] | undefined;
}

export interface FilterOptionInt {
    name?: string | undefined;
    optionSearchName?: string | undefined;
}

export interface FilterOptionInterval {
    name?: string | undefined;
    optionSearchFrom?: string | undefined;
    optionSearchTo?: string | undefined;
    maxValue?: number;
}

export interface FilterOptionMultiSelect {
    name?: string | undefined;
    optionSearchName?: string | undefined;
    optionSearchValues?: number[] | undefined;
}

export interface FilterOptionPriceInterval {
    name?: string | undefined;
    optionSearchFrom?: string | undefined;
    optionSearchTo?: string | undefined;
    maxValue?: number;
    currencyText?: string | undefined;
    currency?: string | undefined;
}

export interface FilterOptionText {
    name?: string | undefined;
    optionSearchName?: string | undefined;
    options?: OptionText[] | undefined;
}

export interface FilterOptionsResponseModel {
    price?: FilterOptionPriceInterval;
    bedrooms?: FilterOptionInterval;
    bathrooms?: FilterOptionInt;
    distanceToWater?: FilterOptionMultiSelect;
    propertyTypes?: FilterOptionText;
    popularFacilities?: FilterOptionBool;
    pets?: FilterOptionBool;
    additionalFacilities?: FilterOptionBool;
    smoking?: FilterOptionBool;
}

export interface FinancialAddress {
    accountHolderName?: string | undefined;
    bic?: string | undefined;
    country?: string | undefined;
    iban?: string | undefined;
}

export interface GeneralInformation {
    text?: string | undefined;
    textLastPaymentReminder?: string | undefined;
    paymentUrl?: string | undefined;
}

export interface GtmData {
    bookingId?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    currencyCode?: string | undefined;
    brand?: string | undefined;
    commission?: number;
    breadcrumb?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    propertyCountry?: string | undefined;
    propertyRegion?: string | undefined;
    propertyCity?: string | undefined;
}

export interface Guests {
    adults?: number;
    children?: number;
    infants?: number;
    pets?: number;
}

export interface HybridDetails {
    rentalPrice?: number;
    hybridFeeDetails?: HybridFeeDetail[] | undefined;
}

export interface HybridFeeDetail {
    code?: string | undefined;
    pricePerUnit?: number;
    bookable?: number;
    payment?: number;
    unit?: number;
    name?: string | undefined;
    selected?: number;
}

export interface IntFacilities {
    headline?: string | undefined;
    items?: string[] | undefined;
}

export interface KeyFacilities {
    intFacilities?: IntFacilities;
    boolFacilities?: BoolFacilities;
    distanceFacilities?: DistanceFacilities;
}

export enum Language {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _14 = 14,
    _16 = 16,
    _18 = 18,
    _35 = 35,
    _37 = 37,
    _38 = 38,
    _39 = 39,
    _40 = 40,
    _41 = 41,
    _42 = 42,
    _43 = 43,
    _44 = 44,
    _45 = 45,
    _46 = 46,
    _47 = 47,
    _48 = 48,
    _49 = 49,
    _50 = 50,
    _51 = 51,
    _52 = 52,
    _53 = 53,
    _54 = 54,
    _55 = 55,
    _56 = 56,
    _57 = 57,
    _58 = 58,
    _59 = 59,
    _60 = 60,
    _61 = 61,
    _62 = 62,
    _63 = 63,
    _64 = 64,
    _65 = 65,
    _66 = 66,
    _68 = 68,
    _69 = 69,
    _70 = 70,
    _71 = 71,
    _72 = 72,
    _73 = 73,
    _74 = 74,
    _75 = 75,
    _76 = 76,
    _77 = 77,
    _78 = 78,
    _79 = 79,
    _80 = 80,
    _81 = 81,
    _82 = 82,
    _83 = 83,
    _84 = 84,
    _85 = 85,
    _86 = 86,
    _87 = 87,
    _88 = 88,
    _89 = 89,
    _90 = 90,
    _91 = 91,
    _92 = 92,
    _102 = 102,
    _104 = 104,
    _107 = 107,
    _108 = 108,
    _110 = 110,
    _111 = 111,
    _112 = 112,
    _113 = 113,
    _114 = 114,
    _115 = 115,
    _116 = 116,
    _117 = 117,
}

export interface LanguageInfo {
    language?: Language;
    readonly languageId?: number;
    name?: string | undefined;
}

export enum LogTypes {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _5 = 5,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _20 = 20,
    _21 = 21,
    _22 = 22,
    _23 = 23,
    _24 = 24,
    _25 = 25,
    _29 = 29,
    _30 = 30,
    _31 = 31,
    _32 = 32,
    _37 = 37,
    _38 = 38,
    _39 = 39,
    _40 = 40,
    _41 = 41,
    _42 = 42,
    _43 = 43,
    _44 = 44,
    _45 = 45,
    _46 = 46,
    _47 = 47,
    _48 = 48,
    _49 = 49,
    _50 = 50,
    _51 = 51,
    _52 = 52,
    _53 = 53,
    _54 = 54,
    _55 = 55,
    _56 = 56,
    _57 = 57,
    _58 = 58,
    _59 = 59,
    _60 = 60,
    _61 = 61,
    _62 = 62,
    _63 = 63,
    _64 = 64,
    _65 = 65,
    _66 = 66,
    _67 = 67,
    _68 = 68,
    _69 = 69,
    _70 = 70,
    _71 = 71,
    _73 = 73,
    _74 = 74,
    _75 = 75,
    _76 = 76,
    _77 = 77,
    _78 = 78,
    _79 = 79,
    _80 = 80,
    _81 = 81,
    _82 = 82,
    _83 = 83,
    _84 = 84,
    _85 = 85,
    _86 = 86,
    _87 = 87,
    _88 = 88,
    _89 = 89,
    _90 = 90,
    _91 = 91,
    _92 = 92,
    _93 = 93,
    _94 = 94,
    _95 = 95,
    _96 = 96,
    _97 = 97,
    _98 = 98,
    _99 = 99,
    _100 = 100,
}

export interface MandatoryChoiceFee {
    name?: string | undefined;
    mandatoryChoiceOptions?: MandatoryChoiceOption[] | undefined;
}

export interface MandatoryChoiceOption {
    id?: string | undefined;
    name?: string | undefined;
    price?: number;
    currency?: string | undefined;
    textToReplace?: string | undefined;
}

export interface MandatoryFee {
    name?: string | undefined;
    price?: number;
    currency?: string | undefined;
    included?: boolean;
    tooltip?: string | undefined;
}

export interface MeetingEvent {
    id?: number;
    dateFromUtc?: Date;
    dateToUtc?: Date;
    maxGuests?: number;
    description?: string | undefined;
    address?: string | undefined;
    link?: string | undefined;
    currentParticipants?: number;
    currentParticipantsTotal?: number;
    isOnline?: boolean;
}

export interface MeetingEventParticipant {
    meetingEventId?: number;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    participants?: number;
}

export interface OptionBool {
    name?: string | undefined;
    optionSearchName?: string | undefined;
}

export interface OptionSort {
    name?: string | undefined;
    optionSearchValue?: SortingMethods;
}

export interface OptionText {
    name?: string | undefined;
    optionSearchValue?: number;
}

export interface OptionalFee {
    id?: string | undefined;
    name?: string | undefined;
    options?: OptionalFeeOption[] | undefined;
    tooltip?: string | undefined;
}

export interface OptionalFeeOption {
    price?: number;
    currency?: string | undefined;
    textToReplace?: string | undefined;
    text?: string | undefined;
}

export interface PaymentInformation {
    title?: string | undefined;
    amount?: number | undefined;
    currency?: string | undefined;
    paymentMethodTypes?: string[] | undefined;
    hasUnpaidRate?: boolean;
    publicKey?: string | undefined;
    emailAddress?: string | undefined;
    paymentButtonText?: string | undefined;
    paymentButtonTextToReplace?: string | undefined;
    paymentButtonPrice?: number | undefined;
    unpaidRates?: UnpaidRate[] | undefined;
    isUsagePayment?: boolean;
    bankTransferInformation?: BankTransferInformation;
    allowBankTransfer?: boolean;
    extraPaymentOptions?: string[] | undefined;
    paymentIntentStatus?: string | undefined;
}

export interface PaymentOption {
    name?: string | undefined;
    description?: string | undefined;
    id?: number;
}

export enum PaymentOptions {
    _1 = 1,
    _2 = 2,
}

export interface PaymentRate {
    name?: string | undefined;
    price?: number;
    currency?: string | undefined;
}

export interface Period {
    arrival?: string | undefined;
    departure?: string | undefined;
    nights?: number;
    checkIn?: string | undefined;
    checkOut?: string | undefined;
}

export interface PersonalDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
}

export interface PressureTag {
    name?: string | undefined;
    description?: string | undefined;
    type?: PressureTagType;
}

export enum PressureTagType {
    _0 = 0,
    _1 = 1,
}

export interface PriceAndFeesRequest {
    fromDate?: Date;
    toDate?: Date;
    adults: number;
    children: number;
    infants: number;
    pets?: number;
    bookServices?: { [key: string]: number; } | undefined;
    discountCode?: string | undefined;
    languageCurrencyKey?: string | undefined;
    language?: string | undefined;
    salesPartnerDetails?: SalesPartnerDetails;
    hybridDetails?: HybridDetails;
    throwErrorOnInvalidMandatoryGroupSelection?: boolean;
    feeLanguage?: Language;
    addAdminAndInsuranceMarkupToServices?: boolean;
}

export interface Property {
    name?: string | undefined;
    image?: string | undefined;
    isFlexRent?: boolean;
    rooms?: string | undefined;
    bathrooms?: string | undefined;
    distanceToWater?: string | undefined;
    bedroomCount?: number | undefined;
    bathroomCount?: number | undefined;
    distanceToWaterDistance?: number | undefined;
    distanceToWaterTypeText?: string | undefined;
    sleepingPlaces?: number | undefined;
}

export interface PropertyListingDataApiModel {
    propertyId?: string | undefined;
    title?: string | undefined;
    image?: string | undefined;
}

export interface PropertyResponseModel {
    name?: string | undefined;
    facilitiesList?: FacilitiesList;
    descriptions?: Descriptions;
    reviewList?: ReviewList;
    suggestedPersonalizedProperties?: SuggestionProperties;
    suggestedOtherPropertiesInArea?: SuggestionProperties;
    images?: string[] | undefined;
    breadcrumbs?: BreadcrumbItem[] | undefined;
    coordinate?: Coordinate;
    brand?: string | undefined;
    paymentMethods?: string[] | undefined;
    isDisabled?: boolean;
    areaId?: number;
    pressureTags?: PressureTag[] | undefined;
    country?: string | undefined;
    region?: string | undefined;
    city?: string | undefined;
}

export interface RelatedDestination {
    areaId?: number;
    title?: string | undefined;
    destinationLink?: string | undefined;
    areaName?: string | undefined;
}

export interface RelatedDestinationModel {
    breadcrumbs?: AreaLink[] | undefined;
    destinations?: RelatedDestination[] | undefined;
    title?: string | undefined;
    subTitle?: string | undefined;
}

export interface ReservationError {
    id?: number;
    message?: string | undefined;
    type?: BookingErrors;
    reference?: string | undefined;
    userGuide?: ReservationErrorUserGuide;
}

export interface ReservationErrorDateWithFormat {
    date?: Date;
    formatted?: string | undefined;
}

export interface ReservationErrorUserGuide {
    checkInDates?: ReservationErrorDateWithFormat[] | undefined;
    checkOutDates?: ReservationErrorDateWithFormat[] | undefined;
}

export interface ReservationFee {
    id?: string | undefined;
    groupId?: number;
    name?: string | undefined;
    readonly calculatedPrice?: number;
    calculatedPriceInBookingCurrency?: number;
    readonly calculatedPriceWithVatInBookingCurrency?: number;
    readonly calculatedPriceWithVat?: number;
    calculatedVatInBookingCurrency?: number;
    readonly calculatedVat?: number;
    readonly price?: number;
    readonly vat?: number;
    readonly currencyCode?: string | undefined;
    currency?: DbLiveCurrency;
    priceInBookingCurrency?: number;
    vatInBookingCurrency?: number;
    currencyCodeBooking?: string | undefined;
    description?: string | undefined;
    tooltip?: string | undefined;
    readonly minimumPrice?: number;
    minimumPriceInBookingCurrency?: number;
    maxCount?: number;
    selectedCount?: number;
    feeType?: ReservationFeeType;
    unit?: DbServiceUnits;
    payment?: ReservationFeePayment;
    bookableOption?: ReservationFeeBookableOption;
    selectTexts?: string[] | undefined;
    selectedText?: string | undefined;
    unitText?: string | undefined;
    selectTextWithoutCurrency?: SelectTextWithoutCurrency;
    selectTextsWithoutCurrency?: SelectTextWithoutCurrency[] | undefined;
    mandatoryOptional?: boolean;
}

export enum ReservationFeeBookableOption {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum ReservationFeePayment {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ReservationFeeType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface ReservationFees {
    fees?: ReservationFee[] | undefined;
    readonly serviceGroups?: { [key: string]: ReservationFee[]; } | undefined;
    readonly mandatory?: number;
    readonly totalVat?: number;
    readonly mandatoryInBookingCurrency?: number;
}

export interface ReservationPayment {
    due?: Date;
    payment?: number;
}

export interface ReservationPaymentOption {
    paymentTerms?: ReservationPayment[] | undefined;
    id?: number;
    textId?: number;
}

export interface ReservationPrice {
    available?: boolean;
    onRequest?: boolean;
    readonly priceBeforeDiscount?: number;
    discount?: number;
    readonly priceAfterDiscount?: number;
    fromDate?: Date;
    toDate?: Date;
    readonly currencyCode?: string | undefined;
    readonly currencySign?: string | undefined;
    currency?: DbLiveCurrency;
    readonly obsoleteCurrency?: string | undefined;
    priceInBookingCurrencyBeforeDiscount?: number;
    discountInBookingCurrency?: number;
    priceInBookingCurrencyAfterDiscount?: number;
    currencyCodeBooking?: string | undefined;
    termsConditions?: string[] | undefined;
    errors?: ReservationError[] | undefined;
    readonly hasErrors?: boolean;
    appliedDiscounts?: AppliedDiscount[] | undefined;
}

export interface ReservationPriceFeeResponse {
    readonly calculatedPriceAndFeesAfterDiscount?: number;
    readonly calculatedPriceAndFeesBeforeDiscount?: number;
    price?: ReservationPrice;
    fees?: ReservationFees;
    message?: string | undefined;
    nights?: number;
    paymentOptions?: ReservationPaymentOption[] | undefined;
    flexiblePaymentTooltip?: string | undefined;
    paymentMethods?: string[] | undefined;
    lastFullRefundDay?: string | undefined;
    commissionPercentage?: number;
}

export interface Review {
    author?: string | undefined;
    rating?: number | undefined;
    comment?: string | undefined;
    dateCreated?: string | undefined;
    countryName?: string | undefined;
    reviewRatings?: ReviewRating[] | undefined;
}

export interface ReviewList {
    readonly averageRating?: number;
    readonly reviewCount?: number;
    reviews?: Review[] | undefined;
}

export interface ReviewRating {
    ratingTypeId?: number;
    ratingName?: string | undefined;
    rating?: number;
    comment?: string | undefined;
}

export interface SalesPartnerDetails {
    salesPartner?: number;
    bookingNumber?: string | undefined;
    servicePrices?: { [key: string]: number; } | undefined;
    rentalPrice?: number;
    rentalCommission?: number;
    commissionPercentage?: number;
    cancellationTerm?: number;
    stayPrice?: number;
    isDirectApiBooking?: boolean;
    isAffiliateBooking?: boolean;
}

export interface SearchAreaData {
    country?: string | undefined;
    region?: string | undefined;
    city?: string | undefined;
}

export interface SearchDetailsResponseModel {
    /** This is the price tag text that is shown to the user. */
    priceTag?: string | undefined;
    /** This is week Prices (not exact price the user will pay for the booking). */
    weekPrice?: number;
    weekPriceFrom?: number | undefined;
    weekPriceTo?: number | undefined;
    currency?: string | undefined;
    priceFeeResponse?: ReservationPriceFeeResponse;
}

export interface SearchItem {
    id?: string | undefined;
    name?: string | undefined;
    path?: string | undefined;
    type?: string | undefined;
    url?: string | undefined;
}

export interface SearchResponseModel {
    searchedProperties?: SearchedProperty[] | undefined;
    redirectUrl?: string | undefined;
    alternativeSearches?: AlternativeSearch[] | undefined;
    searchAreaData?: SearchAreaData;
}

export interface SearchedProperty {
    id?: string | undefined;
    lon?: number | undefined;
    lat?: number | undefined;
    maxDiscount?: number | undefined;
    averageRating?: number | undefined;
    reviewCount?: number | undefined;
}

export interface SelectTextWithoutCurrency {
    replacementTag?: string | undefined;
    price?: number;
    currency?: string | undefined;
    selectedText?: string | undefined;
}

export interface SelectedBookingOption {
    id?: string | undefined;
    quantity?: number;
}

export interface SelectedFee {
    name?: string | undefined;
    price?: number;
    currency?: string | undefined;
}

export interface SettlementCost {
    name?: string | undefined;
    price?: number;
    currency?: string | undefined;
}

export interface SettlementTotal {
    name?: string | undefined;
    price?: number;
    currency?: string | undefined;
}

export interface ShortListProperties {
    properties?: PropertyListingDataApiModel[] | undefined;
}

export interface SortOption {
    name?: string | undefined;
    optionSearchName?: string | undefined;
    options?: OptionSort[] | undefined;
}

export interface SortOptionsResponseModel {
    sort?: SortOption;
}

export enum SortingMethods {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export interface StringStringValueTuple {
}

export interface SuggestionProperties {
    properties?: SuggestionProperty[] | undefined;
}

export interface SuggestionProperty {
    image?: string | undefined;
    propertyLink?: string | undefined;
    title?: string | undefined;
    averagePrice?: number;
    stayPeriod?: StringStringValueTuple;
    averageRating?: number | undefined;
    sampleReview?: Review;
}

export interface ThemeFacilities {
    headline?: string | undefined;
    priority?: number;
    closed?: boolean;
    items?: Facility[] | undefined;
}

export interface TotalPrice {
    currency?: string | undefined;
    beforeDiscount?: number;
    afterDiscount?: number;
    discountPercentage?: string | undefined;
    hasDiscount?: boolean;
    depositCurrency?: string | undefined;
    deposit?: number | undefined;
    hasDifferentBookingCurrency?: boolean;
    afterDiscountInBookingCurrency?: string | undefined;
    depositInBookingCurrency?: string | undefined;
    rentalBeforeDiscount?: number | undefined;
    rentalAfterDiscount?: number | undefined;
    rentalDiscount?: number | undefined;
    priceConversionDescription?: string | undefined;
    paymentRates?: PaymentRate[] | undefined;
    selectedFeesInBookingCurrency?: SelectedFee[] | undefined;
    appliedDiscounts?: AppliedDiscount[] | undefined;
}

export interface TrackingData {
    price?: number;
    currency?: string | undefined;
    hashedEmail?: string | undefined;
}

export interface UnpaidRate {
    title?: string | undefined;
    name?: string | undefined;
    price?: number | undefined;
    currency?: string | undefined;
    deadline?: string | undefined;
    automaticPayment?: string | undefined;
    isAutomatic?: boolean;
    isCurrentRate?: boolean;
}

export interface UsageCost {
    name?: string | undefined;
    price?: number;
    currency?: string | undefined;
    hasDifferentBookingCurrency?: boolean;
    priceInBookingCurrency?: string | undefined;
}

export enum WaterDistance {
    _100 = 100,
    _300 = 300,
    _600 = 600,
    _1000 = 1000,
    _1500 = 1500,
    _3000 = 3000,
    _5000 = 5000,
    _10000 = 10000,
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
